import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Sprout, Hammer, TrendingUp, Lightbulb } from 'lucide-react';

const LivingCurriculum = () => {
 return (
 <div className="living-curriculum-page">
 <section className="page-hero">
 <div className="section-container">
 <h1 className="page-title">The Living Curriculum</h1>
 <p className="page-subtitle">
 Learning that prepares children for real life, not just exams.
 </p>
 </div>
 </section>

 <section className="curriculum-intro-section">
 <div className="section-container">
 <p className="intro-text">
 Academic mastery is essential—but it's not enough. Nova Roots children spend significant 
 time each day engaged in real-world learning that builds practical competence, confidence 
 and character.
 </p>
 </div>
 </section>

 <section className="curriculum-areas-section">
 <div className="section-container">
 <div className="curriculum-grid">
 <Card className="curriculum-card">
 <CardContent className="curriculum-content">
 <div className="curriculum-icon">
 <Sprout size={32} />
 </div>
 <h3>Agriculture & Sustainability</h3>
 <p>
 Children grow food from seed to harvest. They learn about soil health, water 
 conservation, composting, and the cycles of nature. Farm-to-table isn't a slogan—it's 
 daily practice.
 </p>
 <div className="curriculum-image">
 <img 
 src="/child-watering.webp" 
 alt="Child watering plants in greenhouse"
 />
 </div>
 <div className="curriculum-image">
 <img 
 src="/family-gardening.jpg" 
 alt="Family engaged in gardening activities together"
 />
 </div>
 <p className="curriculum-why">
 <strong>Why it matters:</strong> Children understand where food comes from, develop 
 responsibility, and connect with natural systems.
 </p>
 </CardContent>
 </Card>

 <Card className="curriculum-card">
 <CardContent className="curriculum-content">
 <div className="curriculum-icon">
 <Hammer size={32} />
 </div>
 <h3>Trade & Craft</h3>
 <p>
 Woodworking, textiles, building, repair. Children learn to make things with their hands, 
 solve practical problems, and develop pride in craftsmanship.
 </p>
 <div className="curriculum-image">
 <img 
 src="/maasai-craft-teaching.jpg" 
 alt="Traditional knowledge transfer - elder teaching child hands-on craft skills"
 />
 </div>
 <p className="curriculum-why">
 <strong>Why it matters:</strong> Hands-on work builds patience, precision, and problem-solving. 
 Children see the direct results of their effort.
 </p>
 </CardContent>
 </Card>

 <Card className="curriculum-card">
 <CardContent className="curriculum-content">
 <div className="curriculum-icon">
 <TrendingUp size={32} />
 </div>
 <h3>Financial Literacy & Enterprise</h3>
 <p>
 Children learn about money, budgeting, trade, and entrepreneurship. They run small 
 enterprises, manage resources, and understand value exchange.
 </p>
 <div className="curriculum-image">
 <img 
 src="/children-learning-money.jpg" 
 alt="Children learning about money and financial literacy through hands-on activities"
 />
 </div>
 <p className="curriculum-why">
 <strong>Why it matters:</strong> Financial competence is rarely taught but universally 
 needed. Children leave Nova Roots understanding how money works.
 </p>
 </CardContent>
 </Card>

 <Card className="curriculum-card">
 <CardContent className="curriculum-content">
 <div className="curriculum-icon">
 <Lightbulb size={32} />
 </div>
 <h3>Leadership & Collaboration</h3>
 <p>
 Children work together on projects, resolve conflicts, lead initiatives, and learn to 
 navigate group dynamics with care and clarity.
 </p>
 <div className="curriculum-image">
 <img 
 src="/children-collaboration.jpg" 
 alt="Children collaborating and working together in learning environment"
 />
 </div>
 <p className="curriculum-why">
 <strong>Why it matters:</strong> The ability to work with others, communicate clearly, 
 and lead with empathy are life skills that matter long after school ends.
 </p>
 </CardContent>
 </Card>
 </div>
 </div>
 </section>

 <section className="farm-animals-section">
 <div className="section-container">
 <h2 className="section-title">Farm Animals & Nature Connection</h2>
 <div className="farm-content">
 <p className="farm-intro">
 Nova Roots children interact daily with farm animals—chickens, goats, sheep, ducks, and bees. These relationships teach responsibility, empathy, and an understanding of animal care and the natural cycles of life.
 </p>
 <div className="farm-images-grid">
 <div className="farm-image-item">
 <img src="/farm-sheep.jpg" alt="Children learning about sheep at the farm" />
 <p>Hands-on learning with farm animals</p>
 </div>
 <div className="farm-image-item">
 <img src="/farm-goats.jpg" alt="Goats in natural outdoor setting" />
 <p>Natural animal care and observation</p>
 </div>
 </div>
 </div>
 </div>
 </section>

 <section className="curriculum-philosophy-section">
 <div className="section-container">
 <div className="philosophy-box">
 <h2>Children Learn How the World Works</h2>
 <p>
 This isn't enrichment or extracurricular. It's core curriculum. Nova Roots believes that 
 learning to grow food, build things, manage money, and work with others is as fundamental 
 as literacy and numeracy.
 </p>
 <p>
 The result? Children who are capable, confident, and genuinely prepared for life beyond school.
 </p>
 </div>
 </div>
 </section>
 </div>
 );
};

export default LivingCurriculum;